/**
 * toggle css classes for elements with a 'data-animate-on-scroll' attribute based on their position in relation to the visible portion of the viewport
 */
const setupAnimateOnScroll = () =>
{
	const elems    = document.querySelectorAll( '[data-animate-on-scroll]' );
	const callback = entries =>
	{
		entries.forEach( entry =>
		{
			if (entry.isIntersecting && entry.target instanceof HTMLElement) {
				entry.target.setAttribute( 'data-visible', '1' );
			}
		} );
	}
	const observer = new IntersectionObserver( callback, {
		threshold: 0.25
	} );

	elems.forEach( elem => observer.observe( elem ) );
};


/**
 *
 */
export default setupAnimateOnScroll;